'use strict';
import pubsubService from './pubsub.service';
import { ChatModuleConfiguration } from '@magview/techpad-upgrade-module';

export class TechpadConfig {
  static $inject = [
    '$http', '$q', '$rootScope', 'authService', 'dataRetrieverService', 'signalrService',
    'techpadInitialConfigProvider', 'appVersionNumber','techpadOptions'];

  constructor($http, $q, $rootScope, authService, dataRetrieverService, signalrService,
    techpadInitialConfigProvider, appVersionNumber,techpadOptions) {
    this.settings = null;
    this._promise = null;
    this.authService = authService;
    this.$rootScope = $rootScope;
    this.dataRetrieverService = dataRetrieverService;
    this.signalrService = signalrService;
    this.techpadInitialConfigProvider = techpadInitialConfigProvider;
    this.$http = $http;
    this.$q = $q;
    this.appVersionNumber = appVersionNumber;
    this.techpadOptions = techpadOptions;
    this.registerOnSettingChange((newSetting) => this.onSettingChanged(newSetting));
  }

  init() {
    if (!this._promise) {
      let deferred = this.$q.defer();
      this._promise = deferred.promise;
      this.authService.ensureMagviewPortal().then(() => {this.loadSettings(deferred)
        this.techpadOptions.init();
      });
    }
    return this._promise;
  }

  reload() {
    this.settings = null;
    this._promise = null;

    return this.init();
  }

  reloadByMagViewUrl(url) {

    this.settings = null;

    let deferred = this.$q.defer();
    this._promise = deferred.promise;

    this.loadSettings(deferred, url)

    return this._promise;
  }

  async loadSettings(deferred, url) {
    try {
      const resp = await this.dataRetrieverService.cachedProxy('techpad-settings', 0, () => {
        let config = { headers:  {} };
        if(!this.authService.loggedIn){
          config.headers = this.authService.getTechpadDiagramHeaders();
        }            
        let result;
        let currentMagViewUrl = this.authService.currentMagViewUrl();
        
        if (currentMagViewUrl){
          result = this.$http.get((url || currentMagViewUrl) + '/api/worklist/TechpadSettings', config);
        } else {
          result = {};
        }
        return result;
      });

      this.settings = resp.data;

      if (this.settings && this.settings.IsShowChatMenuItem) {
        ChatModuleConfiguration.apiEndpoint = this.settings.ChatServiceUrl;
        for (var key in ChatModuleConfiguration.storageKey) {
          if (ChatModuleConfiguration.storageKey.hasOwnProperty(key) && ChatModuleConfiguration.storageKey[key].indexOf(this.appVersionNumber) === -1) {
            ChatModuleConfiguration.storageKey[key] = `${this.appVersionNumber}_${ChatModuleConfiguration.storageKey[key]}`;
          }
        }

        if(this.authService.loggedIn){
          pubsubService.dispatch('CHAT_MODULE_MAKE_INITIAL_LOAD');
        }        
      }

      this.$rootScope.techpadSettings = this.settings;    
      deferred.resolve(resp);
    } catch (error) {
      this.settings = {};
      this.$rootScope.techpadSettings = this.settings;
      deferred.resolve();

      if (error.status === 401 && !this.techpadInitialConfigProvider.allowAnonymous()) {
        this.authService.logout();
      }
    }
  }

  onSettingChanged(newSettings) {
    this.settings = newSettings;
    this.$rootScope.techpadSettings = newSettings;
  }

  registerOnSettingChange(fun) {
    this.signalrService.worklist.on('settingChanged', fun);

    return {
      unsubscribe: () => {
        this.signalrService.worklist.off('settingChanged', fun);
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/scripts/services/techpadConfig.js